import { render, staticRenderFns } from "./ImportacaoPagamentos.vue?vue&type=template&id=213e824c&"
import script from "./ImportacaoPagamentos.vue?vue&type=script&lang=js&"
export * from "./ImportacaoPagamentos.vue?vue&type=script&lang=js&"
import style0 from "./ImportacaoPagamentos.vue?vue&type=style&index=0&id=213e824c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports